import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Spotify: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={size ?? '21'} height={size ?? '21'} fill="none" viewBox="0 0 21 21" data-testid="spotify-icon">
      <path
        fill={color ?? '#1ed760'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fillOpacity: 1,
        }}
        d="M10.5.035C4.719.035.031 4.723.031 10.504S4.72 20.969 10.5 20.969s10.469-4.684 10.469-10.465S16.28.035 10.5.035Zm4.8 15.098a.65.65 0 0 1-.898.215c-2.457-1.5-5.55-1.84-9.195-1.008a.652.652 0 1 1-.29-1.273c3.985-.91 7.407-.52 10.165 1.167.309.188.406.59.219.899Zm1.282-2.852a.818.818 0 0 1-1.125.27c-2.812-1.73-7.102-2.23-10.43-1.219a.82.82 0 0 1-1.02-.547.815.815 0 0 1 .548-1.015c3.8-1.153 8.527-.594 11.758 1.39a.817.817 0 0 1 .269 1.121Zm.11-2.969C13.315 7.31 7.75 7.126 4.531 8.102a.979.979 0 1 1-.57-1.871c3.698-1.126 9.843-.907 13.73 1.398a.98.98 0 0 1-1 1.684Zm0 0"
      />
    </svg>
  );
};

export default Spotify;
